import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18.101",
  height: "18.101",
  viewBox: "0 0 18.101 18.101"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { transform: "translate(7068.455 -11455.545)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M25.817,18.1h18.1V0h-18.1Zm17.218-.884H39.274V13.48H37.326v1.948H32.41V13.48H30.461v3.738H26.7V7.227h2.22V5.007H40.815v2.22h2.22Z",
    transform: "translate(-7094.272 11455.545)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M36.187,3.591v2.9H32.154v-2.9H26.377v3.33H31.7V8.938h4.916V6.921h5.324V3.591ZM31.27,6.06H29.685V4.475H31.27Zm7.363,0H37.048V4.475h1.586Z",
    transform: "translate(-7093.564 11460.09)"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}